export default __webpack_public_path__ + "static/media/img.edc4afe8.svg";